import { useState } from 'react';
import ReporterProgramModal from './ReporterProgramModal';

export default function ReporterProgramCTA() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="py-16 md:py-24 bg-gradient-to-br from-green-600 to-green-700">
        <div className="max-w-6xl mx-auto px-4 md:px-6 text-center">
          <div className="inline-block px-4 py-2 bg-white/20 text-white text-sm font-semibold rounded-full mb-6 whitespace-nowrap">
            Now Accepting Applications
          </div>
          
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Reporter-In-Residence Program
          </h2>
          
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Launch your journalism or PR career in the AI era with structured training, mentorship, and real-world experience
          </p>

          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-green-600 text-base font-semibold rounded-full hover:bg-gray-50 transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span>Apply Now</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <div className="text-sm text-white/90 font-medium">6-Month Program</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-user-star-line text-2xl text-white"></i>
              </div>
              <div className="text-sm text-white/90 font-medium">Expert Mentors</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-briefcase-line text-2xl text-white"></i>
              </div>
              <div className="text-sm text-white/90 font-medium">Real Projects</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <div className="text-sm text-white/90 font-medium">Certificate</div>
            </div>
          </div>
        </div>
      </section>

      <ReporterProgramModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
